import React from 'react'
import { Location } from '@reach/router'
import { QueryParamProvider } from 'use-query-params'

const QueryParamLocationProvider = ({ children }) => {
  return (
    <Location>
      {({ location }) => (
        <QueryParamProvider location={location}>{children}</QueryParamProvider>
      )}
    </Location>
  )
}

export default QueryParamLocationProvider
